import { render } from "./ApprovalRequiredInfoBox.vue?vue&type=template&id=982f885a"
import script from "./ApprovalRequiredInfoBox.vue?vue&type=script&lang=js"
export * from "./ApprovalRequiredInfoBox.vue?vue&type=script&lang=js"

import "./ApprovalRequiredInfoBox.vue?vue&type=style&index=0&id=982f885a&lang=css"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__